import { useEffect, useState } from "react";
import { useModalConfirmActionStore } from "../../../stores/admin/modalConfirmActionStore";
import { useTranslation } from "react-i18next";

interface ModalConfirmProps {}

const ModalConfirmAction: React.FC<ModalConfirmProps> = () => {
  const isOpen = useModalConfirmActionStore((state) => state.modalOpen);
  const { message, confirmAction, setWaitTime, waitTime, showWaitTimeInput, setShowWaitTimeInput } = useModalConfirmActionStore();
  const { t } = useTranslation();
  const [isMouseOutside, setIsMouseOutside] = useState(false);
  const [hours, setHours] = useState(waitTime.hours.toString());
  const [minutes, setMinutes] = useState(waitTime.minutes.toString());

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  useEffect(() => {
    setWaitTime(parseInt(hours || "0", 10), parseInt(minutes || "0", 10));
  }, [hours, minutes, setWaitTime]);

  if (!isOpen) return null;

  const closeModal = () => {
    useModalConfirmActionStore.setState({ modalOpen: false });
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;
    if (target.classList.contains("bg-black")) {
      setIsMouseOutside(true);
    } else {
      setIsMouseOutside(false);
    }
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLDivElement>) => {
    if (isMouseOutside) {
      const target = event.target as HTMLDivElement;
      if (target.classList.contains("bg-black")) {
        closeModal();
      }
    }
  };

  const handleSubmit = () => {
    setWaitTime(parseInt(hours || "0", 10), parseInt(minutes || "0", 10));
    confirmAction(waitTime); // Передаем waitTime при подтверждении
    closeModal();
  };

  return (
    <div
      className="fixed top-0 left-0 z-50 w-full h-full flex justify-center items-center bg-black bg-opacity-60"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div className="relative bg-content2 p-8 rounded-lg w-126 min-h-72 text-center flex flex-col justify-between animate-fade-in">
        <button
          className="absolute top-4 right-4 bg-transparent text-textsecondary text-3xl"
          onClick={() => closeModal()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="text-2xl mb-4">{message}</h2>

        {showWaitTimeInput && (
          <div className="flex justify-center gap-4 mb-4">
            <div>
              <label className="block text-sm mb-1">{t("Hours")}</label>
              <input
                type="number"
                min={0}
                className="w-20 px-2 py-1 border rounded text-center border-x-0 h-11 text-2xl
                border-primary block bg-tablebg dark:border-tableline 
                text-primary"    
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                onBlur={(e) => setHours(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm mb-1">{t("Minutes")}</label>
              <input
                type="number"
                min={0}
                max={59}
                className="w-20 px-2 py-1 border rounded text-center border-x-0 h-11 text-2xl
                border-primary block bg-tablebg dark:border-tableline 
                text-primary"                
                value={minutes}
                onChange={(e) => setMinutes(e.target.value)}
                onBlur={(e) => setMinutes(e.target.value)}
              />
            </div>
          </div>
        )}

        <button
          className="text-center cursor-pointer rounded-lg bg-primary h-11 w-full hover:animate-pulse transition duration-300 ease-in-out mt-2"
          onClick={handleSubmit}
        >
          {t("Submit")}
        </button>

        <button
          className="text-center cursor-pointer rounded-lg bg-secondary h-11 w-full hover:animate-pulse transition duration-300 ease-in-out mt-2"
          onClick={closeModal}
        >
          {t("Cancel")}
        </button>
      </div>
    </div>
  );
};

export default ModalConfirmAction;